import { useId } from 'react';
import { Stack } from '@mui/material';
import { ToggleButtonSelect } from 'framework/ui/mui-builder';
import type { FieldElement } from '../../format/form-definition';
import { useBuilder } from '../context';
import { requiredName, validationOf } from './rules';
import { RuleExtras, RuleHead } from './RuleParts';

const CHOICE = {
  NO: 'no',
  ALWAYS: 'always',
} as const;

type Choice = (typeof CHOICE)[keyof typeof CHOICE];

export const RequiredRule = ({ field }: { field: FieldElement }) => {
  const { edit } = useBuilder();
  const required = validationOf(field, 'required');
  const nameId = useId();
  const choice: Choice = required ? CHOICE.ALWAYS : CHOICE.NO;

  const choose = (next: Choice) => {
    if (next === CHOICE.NO) {
      edit({ kind: 'removeValidation', fieldId: field.id, validationKind: 'required' });
    }
    if (next === CHOICE.ALWAYS) {
      edit({ kind: 'setValidation', fieldId: field.id, validation: { ...required, kind: 'required' } });
    }
  };

  return (
    <Stack useFlexGap spacing={1.5}>
      <RuleHead name={requiredName(field)} nameId={nameId}>
        <ToggleButtonSelect
          value={choice}
          onChange={choose}
          aria-labelledby={nameId}
          options={[
            { value: CHOICE.NO, label: 'No' },
            { value: CHOICE.ALWAYS, label: 'Always' },
          ]}
        />
      </RuleHead>
      {required && <RuleExtras field={field} validation={required} />}
    </Stack>
  );
};
